import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <section className="bg-gradient-to-br from-[#FCD4FE] to-[#9BCFFF] py-20 lg:py-36 relative overflow-hidden min-h-screen">
      <div className="container mx-auto px-4 lg:px-0 relative z-10">
        <div className="w-full text-center flex flex-col items-center justify-center min-h-screen">
          <h1 className="text-8xl md:text-[300px] font-bold mb-6 text-[#222831] animate-fade-in-up">
            4<span className="text-[#C52DF8]">0</span>4
          </h1>
          <h2 className="text-4xl md:text-5xl mb-8 text-[#222831] font-bold animate-fade-in-up animation-delay-100">
            Oops! Looks Like a Lost Track
          </h2>
          <p className="md:text-xl font-light max-w-[577px] mx-auto text-[#393E46] mb-12 animate-fade-in-up animation-delay-200">
            The page you're looking for seems to have gone missing. You can use the buttons below to return to the home page or try searching.
          </p>

          <div className="flex flex-col sm:flex-row gap-6 animate-fade-in-up animation-delay-300">
            <Link 
              to="/" 
              className="btn-primary px-8 py-3 rounded-full bg-[#222831] text-white hover:bg-white hover:text-[#222831] hover:border-2 border-[#222831] transition-all"
            >
              Back to Home
            </Link>
            <Link 
              to="/contact" 
              className="btn-secondary px-8 py-3 rounded-full border-2 border-[#222831] text-[#222831] hover:bg-[#222831] hover:text-white transition-all"
            >
              Contact Us
            </Link>
          </div>

          <div className="mt-12 text-center">
            <p className="text-[#393E46] mb-4">Or explore our services:</p>
            <div className="flex flex-wrap justify-center gap-4">
              <Link to="/services" className="text-[#C52DF8] hover:underline">Services</Link>
              <Link to="/about" className="text-[#C52DF8] hover:underline">About Us</Link>
              <Link to="/music-publishing" className="text-[#C52DF8] hover:underline">Music Publishing</Link>
              <Link to="/artist-services" className="text-[#C52DF8] hover:underline">Artist Services</Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NotFound;
